import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    fetch('/portfolio/data/stats.json')
      .then(r => r.json())
      .then(stats => {
        this.element.querySelectorAll('[data-stat]').forEach(el => {
          const key = el.dataset.stat
          if (stats[key] !== undefined) {
            el.dataset.target = String(stats[key])
          }
        })
      })
      .catch(() => {})
  }
}
